module.exports = __webpack_public_path__ + "static/assets/8503c5d7311a6bfd9f5e43d5a93ef84b.png";